import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import { PCOperations } from "../../../../../redux/pageConfiguration/pcOperators";
import { LogoTypeJewelry } from "./PC_LogoTypeJewelry";
import iconPlusCircle from "../../../../../assets/images/icons/icon-Plus-circle.svg";
import iconX from "../../../../../assets/images/icon-x-circle2.svg";
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";
import Spinner from "react-bootstrap/Spinner";

export const AddTypeJewelry = ({ theme, PCInformation, id }) => {
  const [t] = useTranslation("global");
  const dispatch = useDispatch();
  const [typeJewelry, setTypeJewelry] = useState("");
  const [loading, setLoading] = useState(false);
  let lengthJewelry = PCInformation.pcTypeJewelry.length;

  const deleteTypeJewelry = async (element, index) => {
    dispatch(PCOperations.deleteTypeJewelry(element, index));

    if (lengthJewelry === 1) {
      dispatch(
        PCOperations.changeCheckTypeJewelry(
          0,
          PCInformation.PCInformation.id_user,
          lengthJewelry,
          ""
        )
      );
    }
  };
  const handleImageUpload = async (enlaceUrl, element, index) => {
    const updatedList = [...PCInformation?.pcTypeJewelry];
    updatedList[index] = { ...updatedList[index], image: enlaceUrl };
    dispatch(PCOperations.updateImageTypeJewelry(enlaceUrl, element));
  };

  const handleSubmit = () => {
    const newTodo = { name: typeJewelry };
    if (newTodo.name !== "") {
      dispatch(
        PCOperations.addTypeJewelry(
          newTodo,
          PCInformation.PCInformation.id_user,
          t
        )
      );

      if (lengthJewelry === 0) {
        dispatch(
          PCOperations.changeCheckTypeJewelry(
            1,
            PCInformation.PCInformation.id_user,
            lengthJewelry,
            newTodo
          )
        );
      }
    }
    setTypeJewelry("");
  };

  const deleteImage = async (e, element) => {
    dispatch(PCOperations.deleteImageJewelry(element));
  };

  const handleDragEnd = (result) => {
    if (!result.destination) {
      return;
    }
    const items = Array.from(PCInformation?.pcTypeJewelry);
    const [reorderedItem] = items.splice(result.source.index, 1);
    items.splice(result.destination.index, 0, reorderedItem);
    setLoading(true);
    dispatch(PCOperations.saveTypeJewelry(items));
    setTimeout(() => {
      setLoading(false);
    }, 1000);
  };

  return (
    <>
      {loading ? (
        <div className="cityList">
          <div className="spinner-container">
            <Spinner animation="border" variant="primary" />
          </div>
        </div>
      ) : (
        <div className="todo-list">
          <div className="file-input">
            <p className="cityAndStudio color-text-secondary">
              {" "}
              {t("budget.jewelry")}
            </p>
            <div className="div-input-add-city">
              <input
                onChange={(e) => setTypeJewelry(e.target.value)}
                value={typeJewelry === null ? "" : typeJewelry}
                className="inputCity bg-input color-text-secondary"
                id="task"
                type="text"
                name="task"
                placeholder={t("pageConfiguration.jewelryPlaceholder")}
              />
              <button className="buttonCityAdd" onClick={() => handleSubmit()}>
                <img
                  className={theme === 1 ? "no-filter-img" : ""}
                  src={iconPlusCircle}
                  alt="buttonADD"
                />
              </button>
            </div>

            {PCInformation?.pcTypeJewelry?.length !== 0 && (
              <>
                <p className="p-add-artist color-text-secondary">
                  {t("pageConfiguration.addedTypeJewelry")}
                </p>
              </>
            )}
          </div>
          <div className="cityList">
            <DragDropContext onDragEnd={handleDragEnd}>
              <Droppable droppableId="artistList">
                {(provided) => (
                  <div {...provided.droppableProps} ref={provided.innerRef}>
                    {PCInformation?.pcTypeJewelry?.map((element, index) => (
                      <Draggable
                        key={index}
                        draggableId={`artist-${index}`}
                        index={index}
                      >
                        {(provided) => (
                          <div
                            ref={provided.innerRef}
                            {...provided.draggableProps}
                            {...provided.dragHandleProps}
                            className="cityElementList color-border div-margin-padding"
                          >
                            {element.image ? (
                              <div className="logoInitialEmployed">
                                <div className="employed-left">
                                  <div className="employed-l">
                                    <button
                                      className="btn-delete-city"
                                      size="small"
                                      onClick={() =>
                                        deleteTypeJewelry(element, index)
                                      }
                                      shape="circle"
                                    >
                                      <img
                                        className={
                                          theme === 1 ? "filter-img" : ""
                                        }
                                        src={iconX}
                                        alt="x"
                                      />
                                    </button>
                                    <p
                                      translate="no"
                                      className="p-add-employed color-text-secondary"
                                    >
                                      {element.type_name}
                                    </p>
                                  </div>
                                </div>
                                <div className="employed-right">
                                  <div
                                    className="employed-right file-upload"
                                    onClick={(e) => deleteImage(e, element)}
                                  >
                                    <p className="p-add-image text-color m-2">
                                      {t(
                                        "pageConfiguration.deleteImagePCAddArtist"
                                      )}
                                    </p>
                                  </div>
                                  <img
                                    className="image-employed object-artist"
                                    src={element?.image}
                                    alt=""
                                  />
                                </div>
                              </div>
                            ) : (
                              <LogoTypeJewelry
                                theme={theme}
                                element={element}
                                index={index}
                                deleteTypeJewelry={deleteTypeJewelry}
                                onImageUpload={handleImageUpload}
                                id={id}
                              />
                            )}
                          </div>
                        )}
                      </Draggable>
                    ))}
                    {provided.placeholder}
                  </div>
                )}
              </Droppable>
            </DragDropContext>
          </div>
        </div>
      )}
    </>
  );
};
